'use strict';

var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = withStyles.chainPropTypes(defaultTheme.propTypes.exports.elementType, elementTypeAcceptingRef);

/**
 * Selector compatible with the focus-visible polyfill.
 *
 * Safari does not support focus-selected at the moment so we need
 *   to use this polyfill. In order to support all browsers we
 *   need to use this selector instead of :focus-visible
 */
var focusVisibleSelectorMixin = "[data-focus-visible-added]";

exports.elementTypeAcceptingRef = elementTypeAcceptingRef$1;
exports.focusVisibleSelectorMixin = focusVisibleSelectorMixin;
//# sourceMappingURL=focus-visible-selector-7139d43f.js.map
